import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    Box
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const WorkSpaceSetupOLd = ({ open, onClose, folderData, onConfirm }) => {
    const [selectedFolder, setSelectedFolder] = useState(null);

    // Get the children from the first item of the data array
    const folders = folderData?.[0]?.children || [];
    const rootName = folderData?.[0]?.folderName || "Select Folder";

    const handleSelect = (folder) => {
        setSelectedFolder(folder);
    };

    const handleConfirm = () => {
        if (selectedFolder) {
            onConfirm(selectedFolder);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                <Typography variant="h6" component="div" sx={{ fontFamily: 'Outfit', fontWeight: 600 }}>
                    {rootName}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    Select a sub-folder to proceed
                </Typography>
            </DialogTitle>

            <DialogContent dividers sx={{ maxHeight: '400px', p: 0 }}>
                <List>
                    {folders.map((folder) => (
                        <ListItem key={folder.folderId} disablePadding>
                            <ListItemButton
                                selected={selectedFolder?.folderId === folder.folderId}
                                onClick={() => handleSelect(folder)}
                                sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: '#E1FFBB',
                                        '&:hover': { backgroundColor: '#d4f0ad' }
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <FolderIcon sx={{ color: '#FFB020' }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={folder.folderName}
                                    primaryTypographyProps={{
                                        style: { fontFamily: 'Outfit', fontSize: '14px' }
                                    }}
                                />
                                {selectedFolder?.folderId === folder.folderId && (
                                    <CheckCircleIcon sx={{ color: '#34A853', fontSize: '20px' }} />
                                )}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button
                    onClick={onClose}
                    sx={{ color: '#666', fontFamily: 'Outfit' }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!selectedFolder}
                    sx={{
                        backgroundColor: '#34A853',
                        '&:hover': { backgroundColor: '#2d8f47' },
                        fontFamily: 'Outfit'
                    }}
                >
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WorkSpaceSetupOLd;